const METRIC_INCIDENTS = 'incidents';
const METRIC_AVAILABILITY = 'availability';
const METRIC_ACTIVE_MENU = 'active_menu';
const METRIC_RATING = 'rating';
const LEVEL_A = 'A';
const LEVEL_B = 'B';
const LEVEL_C = 'C';
const ORDERS_PER_HUNDRED = 100;
const INCIDENTS_DECIMALS = 4;
const INCIDENTS_PER_HUNDRED_DECIMALS = 2;
const PERCENT_DECIMALS = 0;
const RATING_DECIMALS = 1;
const SCORE_DECIMALS = 2;

const formatNumber = (value, decimals) =>
  String(Number(Number(value).toFixed(decimals))).replace('.', ',');

const findCutoff = (cutoffs, level) => cutoffs.find(cutoff => cutoff.level === level) || null;

const describeWeight = threshold => `Pesa ${formatNumber(threshold.weight, PERCENT_DECIMALS)} % del nivel.`;

const describeIncidentsWeight = threshold => {
  if (!threshold.scale_orders) {
    return describeWeight(threshold);
  }

  return `Pesa hasta ${formatNumber(threshold.weight, PERCENT_DECIMALS)} % del nivel: el peso completo llega con ${formatNumber(
    threshold.scale_orders,
    PERCENT_DECIMALS
  )} pedidos en la quincena y con menos pedidos pesa menos, nunca menos de ${formatNumber(
    threshold.floor_weight,
    PERCENT_DECIMALS
  )} %.`;
};

const describeIncidentsRange = threshold => {
  const fullScoreAt = Number(threshold.full_score_at);
  const zeroScoreAt = Number(threshold.zero_score_at);

  return `Suma todo con ${formatNumber(fullScoreAt, INCIDENTS_DECIMALS)} o menos (${formatNumber(
    fullScoreAt * ORDERS_PER_HUNDRED,
    INCIDENTS_PER_HUNDRED_DECIMALS
  )} por cada 100 pedidos) y nada desde ${formatNumber(zeroScoreAt, INCIDENTS_DECIMALS)} (${formatNumber(
    zeroScoreAt * ORDERS_PER_HUNDRED,
    INCIDENTS_PER_HUNDRED_DECIMALS
  )} por cada 100 pedidos).`;
};

const describePercentRange = threshold =>
  `Suma todo con ${formatNumber(threshold.full_score_at, PERCENT_DECIMALS)} % o más y nada con ${formatNumber(
    threshold.zero_score_at,
    PERCENT_DECIMALS
  )} % o menos.`;

const describeRatingRange = threshold =>
  `Suma todo con ${formatNumber(threshold.full_score_at, RATING_DECIMALS)} o más y nada con ${formatNumber(
    threshold.zero_score_at,
    RATING_DECIMALS
  )} o menos.`;

const describeRatingSample = threshold =>
  Number(threshold.minimum_sample) > 0
    ? ` Cuenta solo si tienes ${formatNumber(threshold.minimum_sample, PERCENT_DECIMALS)} reseñas o más en la quincena.`
    : '';

const METRIC_HELP_TEXT_BUILDERS = {
  [METRIC_INCIDENTS]: threshold =>
    `Reclamos de tus clientes, pesados por su gravedad (de leve a crítico), por cada pedido de la quincena. ${describeIncidentsWeight(
      threshold
    )} ${describeIncidentsRange(threshold)}`,
  [METRIC_AVAILABILITY]: threshold =>
    `Parte del horario que declaraste en que tu tienda estuvo prendida para recibir pedidos. ${describeWeight(
      threshold
    )} ${describePercentRange(threshold)}`,
  [METRIC_ACTIVE_MENU]: threshold =>
    `Parte de tu horario en que los platos de tu carta estuvieron prendidos. ${describeWeight(
      threshold
    )} ${describePercentRange(threshold)}`,
  [METRIC_RATING]: threshold =>
    `Promedio de estrellas que te dan tus clientes. ${describeWeight(threshold)}${describeRatingSample(
      threshold
    )} ${describeRatingRange(threshold)}`
};

export const buildOnDemandMetricHelpText = threshold => {
  const buildHelpText = METRIC_HELP_TEXT_BUILDERS[threshold.metric];

  return buildHelpText ? buildHelpText(threshold) : '';
};

export const buildOnDemandLevelHelpText = cutoffs => {
  const cutoffA = findCutoff(cutoffs, LEVEL_A);
  const cutoffB = findCutoff(cutoffs, LEVEL_B);
  const levelRanges =
    cutoffA && cutoffB
      ? ` Desde ${formatNumber(cutoffA.minimum_score, SCORE_DECIMALS)} es ${LEVEL_A}, desde ${formatNumber(
          cutoffB.minimum_score,
          SCORE_DECIMALS
        )} es ${LEVEL_B} y por debajo es ${LEVEL_C}.`
      : '';

  return `Tu puntaje va de 0 a 3 y suma tus cuatro métricas según el peso de cada una.${levelRanges} Si a una métrica le faltan datos en la quincena, su peso se reparte entre las demás.`;
};
